<template>
  <!-- mobile menu -->
  <transition name="slide-fade" mode="in-out">
    <div class="mo_all_menu on" v-show="showMobileHeader">
      <div class="w_wrap">
        <div class="tp_wrap">
          <div class="l_box">
            <a role="button" class="close" @click="closeMobileHeader"></a>
            <div class="h_logo">
              <router-link
                @click.native="closeMobileHeader"
                :to="{
                  name: 'home'
                }"
                ><img src="@/assets/images/h_logo.png"
              /></router-link>
            </div>
          </div>
          <div class="nickname">
            <span>{{ username ? `${username}님` : '' }}</span
            ><em class="lv"> {{ memberLevelInfo.name }}</em>
          </div>
        </div>
        <top-header
          @closeHeader="closeMobileHeader"
          :show-mobile-header="showMobileHeader"
        ></top-header>
        <div class="pd_wrap">
          <top-guide></top-guide>
          <div class="category_wrap">
            <ul
              v-for="(categories, index) in treeCategories"
              :key="index"
              @click.capture="checkCategoryIndex"
              @click="activeCategoryIndex = index"
            >
              <li class="li01">
                <div class="tb">
                  <a role="button" :class="changCategoryClass(index)">
                    <p
                      class="pic"
                      :style="changCategoryImage(categories, index)"
                    >
                      <img :src="categories.name" />
                    </p>
                    <span>{{ categories.name }}</span>
                  </a>
                </div>
                <transition name="slide">
                  <div class="dept" v-if="showChildrenCategory(index)">
                    <ul>
                      <li
                        v-for="childCategory in categories.children"
                        :key="childCategory.id"
                        @click="closeMobileHeader"
                      >
                        <router-link
                          :class="changCategoryClass(index)"
                          @click.native="
                            setSearchParams({
                              categoryName: childCategory.wholeName
                            })
                          "
                          :to="{
                            name: 'productList',
                            params: { categoryName: childCategory.wholeName }
                          }"
                          >{{ childCategory.name }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </transition>
              </li>
            </ul>
          </div>
          <div class="recom_sl">
            <swiper
              class="swiper"
              ref="mySwipe3"
              :options="swiperOptionsLeftTop"
            >
              <swiper-slide
                v-for="(promotion_banner, index) in textBanner"
                v-bind:key="index"
              >
                <router-link :to="promotion_banner.url">
                  <span>추천상품</span>
                  <p>{{ promotion_banner.name }}</p>
                </router-link>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { directive, Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

import { mapGetters } from 'vuex'
import { recommProductList } from '@/api/homeData'
import TopGuide from '../TopGuide'
import TopHeader from './components/TopHeader'
import { advertiseList } from '@/api/homeData'

export default {
  name: 'MobileHeader',
  props: {
    showMobileHeader: {
      default: false
    },
    treeCategories: {
      default: Array
    }
  },
  components: {
    TopHeader,
    TopGuide,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  computed: {
    ...mapGetters(['device', 'username', 'memberLevelInfo', 'searchParams'])
  },
  data() {
    return {
      activeCategoryIndex: null,
      lastActiveCategoryIndex: null,
      swiperOptionsLeftTop: {
        direction: 'vertical',
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        height: 72
      },
      recommProducts: [],
      textBanner: []
    }
  },
  methods: {
    closeMobileHeader() {
      this.activeCategoryIndex = null
      this.lastActiveCategoryIndex = null
      this.$scrollToTop()
      this.$emit('update:showMobileHeader', false)
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    checkCategoryIndex() {
      this.lastActiveCategoryIndex =
        this.lastActiveCategoryIndex === this.activeCategoryIndex
          ? null
          : this.activeCategoryIndex
    },
    changCategoryClass(index, categoryName) {
      return this.lastActiveCategoryIndex !== this.activeCategoryIndex &&
        this.activeCategoryIndex === index
        ? 'on'
        : ''
    },
    setSearchParams(params) {
      const copyParams = this.searchParams
      this.$set(copyParams, 'text', '')
      this.$set(copyParams, 'categoryName', params.categoryName)
      this.$set(copyParams, 'subject', undefined)
      console.log(copyParams)
      this.$store.dispatch('SEARCH_PARAMS', copyParams)
    },
    changCategoryImage(categories, clickIndex) {
      return this.lastActiveCategoryIndex !== this.activeCategoryIndex &&
        this.activeCategoryIndex === clickIndex
        ? `backgroundImage:url(${categories.onIcon})`
        : `backgroundImage:url(${categories.menuIcon})`
    },
    showChildrenCategory(index) {
      return (
        this.lastActiveCategoryIndex !== index &&
        this.activeCategoryIndex === index
      )
    },
    getRecommProductList() {
      recommProductList().then(response => {
        this.recommProducts = response.data
      })
    },
    getBannerList() {
      advertiseList(1).then(res => {
        this.textBanner = res.data
      })
    }
  },
  created() {
    this.getRecommProductList()
    this.getBannerList()
  }
  // watch: {
  //   showMobileHeader: {
  //     //
  //   }
  // }
}
</script>

<style scoped>
/*** TRANSITIONS ***/
.slide-fade-enter {
  transform: translateX(-100%);
  opacity: 1;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s;
}

.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: 1;
}

/* my page*/
div.mp_wrap {
  cursor: pointer;
}

.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 200px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Header/MobileHeader.vue